import { Button } from "@/components/ui/button"
import { ChevronLeft, ChevronRight } from "lucide-solid"
import { Show } from "solid-js"
import { Flex } from "styled-system/jsx"

interface QuizNavigationProps {
  currentIndex: number
  totalQuestions: number
  viewState: 'intro' | 'active' | 'review'
  isPending: boolean
  isNextDisabled: boolean
  isPassed: boolean
  onPrev: () => void
  onNext: () => void
  onRetake: () => void
  onSubmit: () => void
}

export default function (props: QuizNavigationProps) {
  const isLastQuestion = () => props.currentIndex === props.totalQuestions - 1

  return (
    <Flex justify="space-between" mt={8}>
      <Button
        variant="outline"
        disabled={props.currentIndex === 0}
        onClick={props.onPrev}
      >
        <ChevronLeft size={16} style={{ "margin-right": "8px" }} />
        Previous
      </Button>

      <Show
        when={isLastQuestion()}
        fallback={
          <Button
            disabled={props.isNextDisabled}
            onClick={props.onNext}
          >
            Next
            <ChevronRight size={16} style={{ "margin-left": "8px" }} />
          </Button>
        }
      >
        <Show
          when={props.viewState === 'active'}
          fallback={
            <Show when={!props.isPassed}>
              <Button variant="outline" onClick={props.onRetake}>
                Retake Quiz
              </Button>
            </Show>
          }
        >
          <Button
            colorPalette="jade"
            loading={props.isPending}
            disabled={props.isNextDisabled}
            onClick={props.onSubmit}
          >
            Submit Answers
          </Button>
        </Show>
      </Show>
    </Flex>
  )
}
